<template>
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <total-filters ref="filters" />
      <b-card no-body class="mb-0">
        <b-table
          class="position-relative"
          :hover="true"
          :items="records"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen"
          @sort-changed="sortChanged"
        >
          <template #cell(actions)="row">
            <b-button size="sm" variant="success" @click="openModal(row.item)">
              <feather-icon icon="EditIcon" size="16" />
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col sm="3">
              <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                <b-form-select
                  v-model="showEntrie"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="entries"
                  @change="changeSizePage"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mt-75" style="font-size: 12px">
              <span> {{ totalElements }} Registros en total</span>
            </b-col>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalElements"
                :per-page="showEntrie"
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="cambioPagina"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>

    <b-modal v-model="showModal" title="Reajuste de Cantidad">
      <b-form>
        <b-form-group label="Cantidad Disponible">
          <b-form-input v-model="currentItem.qtyAvailable" type="number" required />
        </b-form-group>
        <b-form-group label="Cantidad Contable">
          <b-form-input v-model="currentItem.qtyLedger" type="number" required />
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="showModal = false">Cancelar</b-button>
        <b-button variant="primary" @click="saveAdjustment">Guardar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import totalFilters from './totalFilters.vue';
import InventoryService from '@/services/InventoryService';

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      showLoading: false,
      showModal: false,
      records: [],
      currentItem: {},
      fields: [
        { key: 'autopart.uniqueCode', label: 'Codigo Único', sortable: true },
        { key: 'autopart.originalCode', label: 'Codigo Original', sortable: true },
        { key: 'autopart.alterCode', label: 'Codigo Alterno', sortable: true },
        { key: 'autopart.description', label: 'Descripcion', sortable: true },
        { key: 'establishments.name', label: 'Establecimiento', sortable: true },
        { key: 'autopart.AutopartBrand.name', label: 'Marca', sortable: true },
        { key: 'autopart.CarBrands.name', label: 'Modelo', sortable: true },
        { key: 'autopart.autopartCategory.name', label: 'Categoria', sortable: true },
        { key: 'qtyAvailable', label: 'Cantidad Disponible', sortable: true },
        { key: 'qtyLedger', label: 'Cantidad Contable', sortable: true },
        { key: 'actions', label: 'Acciones', sortable: true },
      ],
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      id: 0,
      sort: 'id',
      order: 'asc',
    };
  },
  components: {
    totalFilters,
  },
  mounted() {
    this.getData();
  },
  methods: {
    cambioPagina(e) {
      this.currentPage = e;
    },
    changeSizePage() {
      this.getData();
    },
    sortChanged(data) {
      this.sort = data.sortBy;
      this.order = data.sortDesc ? 'desc' : 'asc';
    },
    openModal(item) {
      this.currentItem = {
        ...item,
        autopartId: item.autopart?.id || null,
        establishmentId: item.establishments?.id || null,
      };
      this.showModal = true;
    },
    async saveAdjustment() {
      if (!this.currentItem.qtyAvailable || !this.currentItem.qtyLedger) {
        this.$swal("Error", "Debe ingresar ambas cantidades.", "error");
        return;
      }

      const confirm = await this.$swal({
        title: '¿Confirmar cambios?',
        text: 'Esto actualizará las cantidades.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, guardar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'mr-3',
          cancelButton: '',
        },
      });

      if (confirm.isConfirmed) {
        this.showModal = false;
        const payload = {
          qtyAvailable: parseInt(this.currentItem.qtyAvailable),
          qtyLedger: parseInt(this.currentItem.qtyLedger),
          autopartId: this.currentItem.autopartId,
          establishmentId: this.currentItem.establishmentId,
        };
        try {
          await InventoryService.updateStock(this.currentItem.id, payload, this.$store);
          this.$swal("Guardado", "Los cambios han sido guardados.", "success");
          this.getData();
        } catch (error) {
          this.$swal("Error", "No se pudo guardar el ajuste.", "error");
        }
      } else {
        this.$swal("Cancelado", "No se han realizado cambios.", "info");
      }
    },
    async getData() {
      this.records = [];
      this.totalElements = 0;
      this.showLoading = true;
      const url = `?limit=${this.showEntrie}&page=${this.currentPage}&order=${this.order}&sort=${this.sort}&filter=${JSON.stringify(
        this.arrayFilters
      )}`;
      const resp = await InventoryService.getAllStocks(url, this.$store);
      if (resp.data.rows.length !== 0) {
        this.records = resp.data.rows;
        this.totalElements = resp.data.rows.length;
      }
      this.showLoading = false;
    },
  },
};
</script>
